import React from 'react';
import { LayersIcon } from 'lucide-react';
const links = [{
  label: 'Termini e Condizioni',
  href: '#termini'
}, {
  label: 'Privacy Policy',
  href: '#privacy'
}, {
  label: 'Contatti',
  href: '#contatti'
}];
export function Footer() {
  return <footer className="w-full bg-blue-50 py-14 md:py-16" data-id="element-100" data-mp="32pp3nums9h1r">
      <div className="mx-auto w-full max-w-4xl px-5 text-center md:px-8" data-id="element-101" data-mp="36oo5359b2vog">
        <p className="inline-flex items-center gap-2 text-base font-extrabold uppercase tracking-wider text-blue-600 md:text-lg md:tracking-widest" data-id="element-102" data-mp="3ufa5qbgzddof">
          <LayersIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-103" data-mp="387e5ix8d5do" />
          Atlante Visivo di Chinesiologia
        </p>

        <p className="mx-auto mt-5 max-w-xl text-blue-900/75" data-id="element-104" data-mp="3lgooqkr5q6pr">
          Materiale digitale | Accesso immediato | Garanzia di soddisfazione di 7 giorni
        </p>

        <ul className="mt-8 flex flex-wrap items-center justify-center gap-x-7 gap-y-3 text-blue-900/75" data-id="element-105" data-mp="29yds9o7gci43">
          {links.map(link => <li key={link.label} data-id="element-106" data-mp="3l9k4zam1djc8">
              <a href={link.href} className="transition-colors duration-150 ease-out hover:text-blue-600" data-id="element-107" data-mp="3l8qxg7f96pt1">
                {link.label}
              </a>
            </li>)}
        </ul>

        <p className="mt-10 border-t border-blue-100 pt-6 text-sm text-blue-900/50" data-id="element-108" data-mp="3v5n5yd55jbxl">
          © 2026 Atlante Visivo di Chinesiologia. Tutti i diritti riservati.
        </p>
      </div>
    </footer>;
}